<template>
	<Overlay
		title="Gebruik van persoonsgegevens"
		ref="overlay"
		class="overlay--gdpr"
		:root="true"
		@close="onClose"
		@afterhide="onAfterHide"
	>
		<template #body>
			<slot name="body">
				<p>Via de module 'vrijwilligers' hebben jullie als lokaal bestuur toegang tot informatie over de vrijwilligers en burgers die gebruik hebben gemaakt van de mobiele app van Mooimakers om een opruimsessie of melding te registreren binnen jullie werkingsgebied.</p>
				<p>Als lokaal bestuur krijgen jullie daarbij ook toegang tot persoonsgegevens zoals naam en e-mailadres van deze gebruikers. De gebruikers worden over deze informatiedeling tussen Mooimakers en het lokaal bestuur ingelicht in de privacyverklaring van Mooimakers.</p>
				<p>Het verder gebruik van de voormelde persoonsgegevens door het lokaal bestuur behoort evenwel tot de eigen verantwoordelijkheid van het lokaal bestuur, dat daarbij optreedt als verwerkingsverantwoordelijke onder de Algemene Verordening Gegevensbescherming (AVG). Mooimakers is immers niet betrokken bij de eigen verwerkingen van persoonsgegevens door het lokaal bestuur.</p>
				<p>Zo dient het lokaal bestuur, indien zij de voormelde gebruikers wenst aan te schrijven aan de hand van de contactgegevens die beschikbaar zijn in de module ‘vrijwilligers’, te beoordelen hoe zij dit overeenkomstig de AVG wenst te verwezenlijken. In het bijzonder dient het lokaal bestuur na te gaan of zij de betrokkenen al dan niet wenst aan te schrijven zonder hun voorafgaande toestemming. </p>
				<FormItem
					v-if="hasCheckbox"
					id="approved"
					ref="approvedCheck"
					type="checkbox"
					label="Dit bericht niet meer tonen"
					v-model="approved"
					:modifiers="['inline', 'checkbox--big']"
				/>
			</slot>
		</template>
		<template #footer>
			<div class="footer-actions-group">
				<button
					class="button button button--filled button--big"
					@click="onClose"
				>
					{{ buttonText }}
				</button>
			</div>
		</template>
	</Overlay>
</template>

<script src="./GdprOverlay.js"></script>
